import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';

import CommonFormComponent from '../../CommonField/CommonFormComponent';
import ImageUploadComponent from '../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommomImageDisplay';
import FieldArrayComponent from '../../CommonFields/FieldArrayComponent';

import messages from '../../../locale/jsonMessages';
import submit from './submit';
import validate from './validate';
import { url, banneruploadDir } from '../../../config';
import { doUploadImageBanner, startBannerUploaderLoader, stopBannerUploaderLoader } from '../../../actions/siteadmin/manageImageBanner';
import { photosShow } from '../../../helpers/photosShow';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import { formatLocaleData } from '../../../helpers/formatLocale';

import cp from '../../../components/commonStyle.css';
import s from './ImageBannerForm.css';

class ImageBannerForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
    bannerUploaderLoading: PropTypes.bool,
    doUploadImageBanner: PropTypes.any.isRequired
  };

  success = async (file, fromServer) => {
    const { image, startBannerUploaderLoader, stopBannerUploaderLoader, doUploadImageBanner, demoRestriction } = this.props;
    let fileName = fromServer.file.filename;
    let oldImage = image != undefined ? image : null;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await startBannerUploaderLoader();
    await doUploadImageBanner(fileName, oldImage);
    await stopBannerUploaderLoader();
  }

  render() {
    const { error, handleSubmit, submitting, initialValues, image, bannerUploaderLoading, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;
    let path = photosShow(banneruploadDir);

    return (
      <div>
        <h1 className='siteAdminHeading'><FormattedMessage {...messages.homepageBanner} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            <div className='siteAdminCenterContainerBox siteAdminCenterContainer'>
              <label className={cx('commonLabelText', cp.spaceBottom3)}>
                <FormattedMessage {...messages.adminBannerImage} />
              </label>
              <ImageUploadComponent
                defaultMessage={formatMessage(messages.photosPlaceholder)}
                componentConfig={{
                  iconFiletypes: ['.jpg', '.png'],
                  multiple: false,
                  showFiletypeIcon: false,
                  postUrl: '/uploadBanner'
                }}
                loaderName={'bannerUploaderLoading'}
                success={this.success}
                imageBanner
              />
              <CommonImageDisplay
                loader={bannerUploaderLoading}
                image={image && path + image}
                imageBanner
              />
            </div>
            <div className="twoColumnGrid">
              <Field
                name="buttonLink1"
                type="text"
                component={CommonFormComponent}
                addonContainerClass={'addonMobileWrapper'}
                isAddon={true}
                suffixLabel={`${url}/`}
                placeholder={formatMessage(messages.buttonLink) + ' 1'}
                labelText={formatMessage(messages.buttonLink) + ' 1'}
                isRequiredInput
              />
              <Field
                name="buttonLink2"
                type="text"
                component={CommonFormComponent}
                addonContainerClass={'addonMobileWrapper'}
                isAddon={true}
                suffixLabel={`${url}/`}
                placeholder={formatMessage(messages.buttonLink) + ' 2'}
                labelText={formatMessage(messages.buttonLink) + ' 2'}
                isRequiredInput
              />
            </div>
            <div className='siteAdminCenterContainerBox'>
              <FieldArray
                name="dynamicImageBanner"
                component={FieldArrayComponent}
                activesFields={['language', 'title', 'buttonLabel', 'buttonLabel2']}
                filedName="dynamicImageBanner"
                selectedLanguage={selectedLanguage}
                isDouble
              />
            </div>
          </div>
          <div className={cx(cp.spaceTop4, 'singleBtnFlexEnd')}>
            <Button bsSize="small" className={cx(cp.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

ImageBannerForm = reduxForm({
  form: 'ImageBannerForm',
  validate
})(ImageBannerForm);

const selector = formValueSelector('ImageBannerForm');

const mapState = (state) => ({
  bannerUploaderLoading: state.loader.bannerUploaderLoading,
  selectedLanguage: selector(state, 'dynamicImageBanner'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

const mapDispatch = {
  startBannerUploaderLoader,
  doUploadImageBanner,
  stopBannerUploaderLoader,
  demoRestriction
};

export default injectIntl(withStyles(cp, s)(connect(mapState, mapDispatch)(ImageBannerForm)));